import HttpService from './commons/HttpService';

const CustomerCreditService = {
  save(customerCredit) {
    if (customerCredit.id && customerCredit.id > 0) {
      return this.update(customerCredit);
    }
    return this.create(customerCredit);
  },
  create(customerCredit) {
    return HttpService.post('/customerCredits', customerCredit);
  },
  update(customerCredit) {
    return HttpService.put(`/customerCredits/${customerCredit.id}`, customerCredit);
  },
  findTotalSumByAppointmentId(appointmentId) {
    return HttpService.get('/customerCredits/totalSum', { params: { appointmentId } });
  },
  findTotalSumByCustomerId(customerId) {
    return HttpService.get('/customerCredits/totalSum', { params: { customerId } });
  },
  findSummary(customerId) {
    return HttpService.get('/customerCredits/summary', { params: { customerId } });
  },
};
export default CustomerCreditService;
